import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["themeIcon"];

  connect() {
    this.syncIcon();
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark");
    localStorage.setItem("theme", isDark ? "dark" : "light");
    this.syncIcon();
  }

  syncIcon() {
    if (!this.hasThemeIconTarget) return;
    const isDark = document.documentElement.classList.contains("dark");
    this.themeIconTarget.className = isDark
      ? "fa-solid fa-sun"
      : "fa-solid fa-moon";
  }
}
